export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/renessans.16776736.svg","height":40,"width":40};